import React from "react";
import {withNamespaces} from "react-i18next";
import {Button} from "react-bootstrap";
import {claimTypes} from "../../../../constants/claim.constants";
import {connect} from "react-redux";

const WidgetSceneDmxManagement = ({dmxList, callbackAction, user, claim, t}) => {

    const claimAccess = user[`c_${claim}`] || null;
    if(claimAccess === claimTypes.NONE) {
        return (
            // return when claims is none
            <React.Fragment/>
        )
    }

    const handleActions = (action) => {
        callbackAction(action);
    };

    const selectIcon = (scene) => {
        let icon = '';
        if (scene.isDefault === null) { icon = 'fas fa-power-off'; }
        else if (scene.isDefault === false) { icon = 'far fa-lightbulb' }
        else { icon = 'fas fa-sun'; }
        return icon;
    };

    const devices = dmxList?.map((device) => {
            const renderButtons = device.pxmModbusScenes.map((daliScene) => {
                return (
                    <Button variant="outline-primary"
                            active={daliScene.isActive}
                            className="m-1"
                            key={daliScene.id}
                            onClick={() => { handleActions(`ChangePxmScene?id=${device.id}&sceneId=${daliScene.id}`) }}>
                        <i className={selectIcon(daliScene)}> </i>
                        {daliScene.label}
                    </Button>
                );
            });

        return (
            <div className="card " key={device.id}>
                <div className="card-header">
                    <div className="card-title d-flex w-100">
                        <b className="align-self-center">{device.label}</b>
                        <div className="ml-auto d-flex">
                            <Button className="m-1"
                                    active={!device.diagnosticMode}
                                    variant="outline-success"
                                    onClick={() => handleActions(`AutomaticPxm?id=${device.id}`)}>
                                <i className="fas fa-sync"> </i> &nbsp; Auto
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="list-group mx-2">
                        <div className="list-group-item list-group-item-action">
                            <div className="row">
                                <div className="col-md-3 d-flex">
                                    <span className="text-wrap font-weight-bold align-self-center">Grupa</span>
                                </div>
                                <div className="col-md-9">
                                    <div className="flex-wrap">
                                        { renderButtons }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    });


    return (
        <div className="mt-2">
            { devices?.length ? (
                devices
            ) : (
                <div className="card">
                    <div className="card-header"><span className="card-title">Light scenes</span></div>
                    <div className="card-body">
                        <div className="text-center p-4">
                            <h3>{ t('dmx-no-content') }</h3>
                        </div>
                    </div>
                </div>
            ) }
        </div>
    );
};
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetSceneDmxManagement));
